module.exports = __webpack_public_path__ + "static/img/code.5774dfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/code.png
// module id = Cwdn
// module chunks = 1